export default "__VITE_ASSET__BKjek0Jm__"